export default "__VITE_ASSET__f760dfc4__"